import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'
import { debounce } from './debounce'
import './scroll'
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)

let mm = gsap.matchMedia()

// Effects

// const horizontalParallax = (element, trigger) => {
//     gsap.to(element, {
//         scrollTrigger: {
//             trigger: trigger,
//             scrub: 1,
//             start: 'top bottom',
//             end: '90% 15%',
//             ease: 'none',
//         },
//         x: '-15%',
//     })
// }

const entryElements = (trigger) => {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: trigger,
      start: 'top 80%',
      end: 'bottom 20%',
      once: true,
    },
  })

  tl.fromTo(
    trigger,
    {
      y: 50,
      opacity: 0,
    },
    {
      y: 0,
      duration: 1.2,
      opacity: 1,
      stagger: 0.6,
    }
  )
}

if (document.querySelector('.entry-element')) entryElements('.entry-element')

// if (document.querySelector('.scroll-to-top')) {
//   gsap.fromTo(
//     '.scroll-to-top',
//     {
//       opacity: 0,
//       visibility: 'hidden',
//       duration: 0.3,
//     },
//     {
//       opacity: 1,
//       visibility: 'visible',
//       duration: 0.3,
//       scrollTrigger: {
//         trigger: '.scroll-to-top',
//         start: 'top -40%',
//         end: 'bottom 10%',
//         toggleActions: 'play play reverse none',
//       },
//     }
//   )
// }

mm.add('(min-width: 1024px)', () => {
  // if (document.querySelector('.horizontal-parallax-1'))
  //     horizontalParallax('.horizontal-parallax-1', '.horizontal-parallax-1')
})
